<template>
	<div class="iuasd702" :class="[size]">
		<transition name="fade">
			<v-date-picker
				mode="single"
				class="date-picker-input-2"
				:value="computedValue"
				:minDate="minDate"
				:maxDate="maxDate"
				:input-props="{ placeholder: 'DD/MM/YYYY', formats: ['YYYY-MM-DD'] }"
				:formats="formats"
				:popover-visibility="'focus'"
				:popover-show-clear-margin="true"
				@input="onInput($event)"
				@popover-did-disappear="$emit('blur')"
			/>
		</transition>
	</div>
</template>

<script>
// 3rd party calendar https://docs.vcalendar.io/api.html#date-picker-props
import { DatePicker } from "v-calendar"
import "v-calendar/lib/v-calendar.min.css"
import dayjs from "dayjs"

/**
 * @description This component can be used for picking one day
 * @prop {ISOString | Date} - it accepts String date or JavaScript Date object
 * @returns {ISOString} - it returns simplified ISOString like so "2019-01-24"
 */
export default {
	components: { "v-date-picker": DatePicker },

	data() {
		return {
			isVisible: false,
			formats: {
				title: "MMMM YYYY",
				weekdays: "W",
				navMonths: "MMM",
				input: ["DD/MM/YYYY", "YYYY-MM-DD", "YYYY/MM/DD"],
				dayPopover: "WWW, MMM D, YYYY",
				data: ["DD/MM/YYYY", "YYYY-MM-DD", "YYYY/MM/DD"]
			}
		}
	},

	props: {
		/**
		 * Value accepts Date object
		 */
		value: {
			/**
			 * @description Accepts {String in ISO date format YYYY-MM-DD}, {Null} or {Date}
			 */
			validator(val) {
				return val === null || typeof val === "string" || val instanceof Date
			},
			required: true,
			default: null
		},
		placeholder: {
			type: String,
			default: ""
		},
		id: {
			type: String
		},
		// Minimum date that user can pick
		// E.g. disallow all past dates
		minDate: {
			type: Date
		},
		// Maximum date that user can pick
		maxDate: {
			type: Date
		},
		size: { type: String }
	},

	computed: {
		computedValue() {
			if (!this.value) return null

			// If value is string, convert it to date
			if (typeof this.value === "string") return new Date(this.value)

			return this.value
		}
	},

	methods: {
		onInput(value) {
			const outputDate = dayjs(value).format("YYYY-MM-DD") // converto to simplified ISOString in utc
			this.$emit("input", outputDate)
		},

		hideCalendar() {
			this.isVisible = false
		}
	}
}
</script>
<style>
/* 3rd party component style rewrites */
@import "../../assets/css/tokens.css";

.popover-origin {
	position: absolute !important;
}

.c-pane {
	box-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.08);
	border-radius: 2px;
}

.c-pane-container {
	position: relative !important;
}

.popover-content-wrapper {
	padding: 0 !important;
}

.align-left {
	border: none !important;
	box-shadow: none !important;
}

.align-left::after {
	display: none !important;
}

/* Selected days */
.c-day-background {
	background-color: var(--color2) !important;
}
</style>
<style src="./index.css"></style>
